import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import nextWithRedux from 'next-redux-wrapper';
import { initStore } from '@grandvisionhq/state';

const withRedux = (App)=>{
    class Wrapper extends React.Component {
        static getInitialProps(props) {
            return swcHelpers.asyncToGenerator(function*() {
                let pageProps = {};
                try {
                    if (typeof App.getInitialProps === 'function') {
                        pageProps = yield App.getInitialProps(props);
                    }
                } finally{
                    const { isServer , store  } = props.ctx;
                    if (isServer) {
                        yield store.close();
                    }
                }
                return pageProps;
            })();
        }
        render() {
            return /*#__PURE__*/ React.createElement(App, swcHelpers.extends({}, this.props));
        }
    }
    return nextWithRedux(initStore)(Wrapper);
};

export { withRedux };
//# sourceMappingURL=with-redux.js.map
